import React, { useEffect, useState } from 'react';
import SubQuestionItem from './SubQuestionItem';

import {
  IoIosArrowDown as ArrowDown,
  IoIosArrowUp as ArrowUp,
} from 'react-icons/io';

import './HomeHealthCare.css';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../store/languageSlice';
import TooltipText from './TooltipText';

const QuestionCard = ({ data, index, handleSelectedQIds, resetCounter }) => {
  const { questionEn, questionAr, linkedHHCFormQuestions, id, tooltipEn } = data;
  const { t, isRtl } = useSelector(selectLanguage);
  const [collapsed, setCollapsed] = useState(true);
  const [selectedSubQIds, setSelectedSubQIds] = useState([]);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
    setSelectedSubQIds([]);
  };

  const handleOnSelectChild = (id) => {
    if (selectedSubQIds.includes(id)) {
      const updatedIds = selectedSubQIds.filter((item) => item !== id);
      setSelectedSubQIds(updatedIds);
    } else {
      setSelectedSubQIds([...selectedSubQIds, id]);
    }
  };

  useEffect(() => {
    setCollapsed(true);
    setSelectedSubQIds([]);
  }, [resetCounter]);

  function getAllIdsFromParentId(data, parentId) {
    let ids = [];

    // Define a recursive function to traverse the data
    function traverseData(data, parentId) {
      data.forEach((item) => {
        // Check if the item's parentId matches the target parentId
        if (item.parentId === parentId) {
          ids.push(item.id); // Add the current item's ID to the array
          // Recursively call traverseData for linkedHHCFormQuestions array
          if (
            item.linkedHHCFormQuestions &&
            item.linkedHHCFormQuestions.length > 0
          ) {
            traverseData(item.linkedHHCFormQuestions, item.id);
          }
        }
      });
    }

    // Call the recursive function to start the traversal
    traverseData(data, parentId);

    return ids;
  }

  useEffect(() => {
    handleSelectedQIds({
      selectedSubQIds,
      mainQId: id,
      subQsIds: getAllIdsFromParentId(linkedHHCFormQuestions, id),
      mainSelected: !collapsed,
      question: isRtl ? questionAr : questionEn,
      questionNumber: index + 1,
    });
  }, [selectedSubQIds, collapsed]);

  

  // const question = isRtl ? questionAr : questionEn;
  const question = isRtl ? questionEn : questionEn;
  const keyId = `${id}${question}`;

  return (
    <div className="card mb-6 ps-8 py-8" key={`${index}${questionEn}`}>
      <div className="flex w-full cursor-pointer justify-between items-center">
        <ul className="mb-0">
          <li>
            <input
              type="checkbox"
              id={keyId}
              checked={!collapsed}
              onChange={toggleCollapse}
            />
            <label htmlFor={keyId}>
              <span className="check"></span> <h3>{question}</h3>
            </label>
          </li>
        </ul>

        <div className="flex flex-row items-end gap-1">
          {linkedHHCFormQuestions?.length > 0 && (
            <div>
              {collapsed ? (
                <ArrowDown className="w-6 h-6" />
              ) : (
                <ArrowUp className="w-6 h-6" />
              )}
            </div>
          )}
          {tooltipEn && <TooltipText text={tooltipEn} /> }
        </div>
      </div>
      {/* <p className="mb-4" style={{ color: '#005A9C' }}>
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry.
      </p> */}
      <div
        className={`content mt-4 ${
          collapsed || linkedHHCFormQuestions?.length == 0 ? 'hidden' : ''
        }`}
      >
        <ul>
          {linkedHHCFormQuestions?.length > 0 &&
            linkedHHCFormQuestions?.map((x, i) => {
              return (
                <SubQuestionItem
                  data={x}
                  key={i}
                  isRtl={isRtl}
                  selectedIds={selectedSubQIds}
                  onToggle={handleOnSelectChild}
                />
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default QuestionCard;
